import React, { ChangeEvent } from 'react';
import { InputText } from '~/components/NovosInputs';
import Separator from '~/components/Separator';
import { useProduto } from '~/pages/Produto/hooks/useProduto';

export const AbaDiversos: React.FC = () => {
  const {
    register,
    control,
    setValue,
    formState: { errors },
  } = useProduto();
  return (
    <>
      <Separator labelText="Compras" />
      <div style={{ maxWidth: '16.375rem' }}>
        <InputText
          name="qtd_est_minimo"
          label="Estoque Mínimo"
          placeholder="0"
          maxLength={13}
          max={9999999999}
          alignRight
          min={0}
          register={register}
          control={control}
          isError={!!errors.qtd_est_minimo}
          onInput={(e: ChangeEvent<HTMLInputElement>) => {
            const numbersOnly = e.target.value.replace(/\D/g, '');
            setValue('qtd_est_minimo', Number(numbersOnly));
          }}
        />
      </div>
    </>
  );
};
